export default __webpack_public_path__ + "static/media/plusIcon.084b4857.svg";